import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { class: "flex items-center justify-between mb-4" }
const _hoisted_3 = { class: "text-xl font-semibold text-blue-900" }
const _hoisted_4 = { class: "text-sm font-normal" }
const _hoisted_5 = { class: "flex items-center space-x-2 text-md" }
const _hoisted_6 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_7 = {
  key: 1,
  class: "space-y-2"
}
const _hoisted_8 = { class: "p-2 rounded-lg" }
const _hoisted_9 = { class: "flex flex-wrap gap-2" }
const _hoisted_10 = {
  key: 0,
  class: "text-gray-700"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "text-lg font-semibold text-blue-900 mb-2" }
const _hoisted_13 = { class: "space-y-3" }
const _hoisted_14 = { class: "text-gray-700" }
const _hoisted_15 = {
  key: 0,
  class: "text-gray-600 italic mt-1"
}
const _hoisted_16 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_17 = { class: "text-sm font-medium text-gray-500" }
const _hoisted_18 = { class: "flex flex-wrap gap-1 mt-1" }
const _hoisted_19 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_20 = { class: "text-sm font-medium text-gray-500" }
const _hoisted_21 = { class: "flex flex-wrap gap-1 mt-1" }
const _hoisted_22 = { class: "p-2" }
const _hoisted_23 = { class: "space-y-2" }
const _hoisted_24 = ["href"]
const _hoisted_25 = {
  id: "content",
  class: "bg-white mx-auto mt-6"
}
const _hoisted_26 = { class: "text-lg text-gray-700 mb-2" }
const _hoisted_27 = {
  key: 0,
  class: "text-lg text-gray-700 mb-2"
}
const _hoisted_28 = {
  key: 1,
  class: "text-lg text-gray-700 mb-2"
}
const _hoisted_29 = {
  key: 2,
  class: "mt-4"
}
const _hoisted_30 = { class: "block text-blue-900 text-lg mb-2" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 3,
  class: "text-sm text-gray-700 mb-2"
}
const _hoisted_33 = { class: "text-xs text-gray-500" }

import {
  ref,
  onMounted,
  onUnmounted,
  PropType,
  reactive,
  watch,
} from "vue";
import { IVocabulary } from "@/models/IIearnEnglish";
import "ant-design-vue/dist/antd.css";
import i18n from "@/services/i18n";
import {
  CloseOutlined,
  EditOutlined,
  SoundOutlined,
} from "@ant-design/icons-vue";
import { getRelativeTime } from "@/utils/global";
import { getVocabularyByDictionary } from "@/api/dictionaryApi";
import { IDictionaryEntry } from "@/models/IDictionaryEntry";


export default /*@__PURE__*/_defineComponent({
  __name: 'DrawerVocaDetail',
  props: {
  drawerVisible: {
    type: Boolean,
    required: true,
  },
  vocabulary: {
    type: Object as PropType<IVocabulary>,
    required: true,
  },
},
  emits: ["close", "edit"],
  setup(__props, { emit: __emit }) {

const dictionaryData = ref<IDictionaryEntry | null>(null);
const isLoading = ref(false);

const playAudio = (audioUrl: string) => {
  const audio = new Audio(audioUrl);
  audio.play();
};

const getInfo = async (word: string) => {
  try {
    isLoading.value = true;
    const response = await getVocabularyByDictionary(word);
    if (response && response.length > 0) {
      dictionaryData.value = response[0];
    }
  } catch (error) {
    console.error(error);
  } finally {
    isLoading.value = false;
  }
};

const emit = __emit;
const props = __props;
const selectedVocabulary = ref<IVocabulary | null>(null);
const show = reactive({
  value: false,
});

watch(
  () => props.drawerVisible,
  (newValue) => {
    show.value = newValue ? true : false;
    if (newValue && props.vocabulary) {
      if (!selectedVocabulary.value) {
        selectedVocabulary.value = {} as IVocabulary;
      }
      getInfo(props.vocabulary.english || "");
      selectedVocabulary.value.created_at = props.vocabulary.created_at;
      selectedVocabulary.value.updated_at = props.vocabulary.updated_at;
      selectedVocabulary.value.id = props.vocabulary.id;
      selectedVocabulary.value.english = props.vocabulary.english || "";
      selectedVocabulary.value.translate = props.vocabulary.translate || "";
      selectedVocabulary.value.image = undefined;
      selectedVocabulary.value.example_sentence =
        props.vocabulary.example_sentence || "";
      selectedVocabulary.value.notes = props.vocabulary.notes || undefined;
      selectedVocabulary.value.is_special =
        props.vocabulary.is_special || false;
    }
  },
  { immediate: true }
);

const isSmallScreen = ref(false);
const handleResize = () => {
  isSmallScreen.value = window.innerWidth <= 640;
};
const handleClose = () => {
  emit("close");
};
onMounted(() => {
  handleResize();
  window.addEventListener("resize", handleResize);
});
onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});

return (_ctx: any,_cache: any) => {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_drawer = _resolveComponent("a-drawer")!

  return (_openBlock(), _createBlock(_component_a_drawer, {
    visible: show,
    closable: false,
    onClose: handleClose,
    width: isSmallScreen.value ? '100%' : 400,
    placement: isSmallScreen.value ? 'bottom' : 'right',
    height: isSmallScreen.value ? '85%' : undefined
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode(_toDisplayString(selectedVocabulary.value?.english?.toUpperCase()) + " ", 1),
            _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
            _createElementVNode("span", _hoisted_4, _toDisplayString(selectedVocabulary.value?.translate), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(EditOutlined), {
              class: "flex items-center cursor-pointer text-blue-900",
              onClick: _cache[0] || (_cache[0] = 
              () => {
                handleClose();
                emit('edit', selectedVocabulary.value);
              }
            )
            }),
            _createVNode(_unref(CloseOutlined), {
              class: "flex items-center cursor-pointer text-blue-900",
              type: "close",
              onClick: handleClose
            })
          ])
        ]),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_a_card, {
                loading: isLoading.value,
                hoverable: false,
                class: "border-none"
              }, null, 8, ["loading"])
            ]))
          : (dictionaryData.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryData.value.phonetics, (phonetic, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "flex items-center space-x-2 bg-white p-2 rounded-md shadow-sm"
                      }, [
                        (phonetic.text)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(phonetic.text), 1))
                          : _createCommentVNode("", true),
                        (phonetic.audio)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              onClick: ($event: any) => (playAudio(phonetic.audio)),
                              class: "p-2 bg-blue-100 rounded-full hover:bg-blue-200 transition-colors"
                            }, [
                              _createVNode(_unref(SoundOutlined), { class: "text-blue-600 flex items-center" })
                            ], 8, _hoisted_11))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryData.value.meanings, (meaning, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "p-2 rounded-lg"
                  }, [
                    _createElementVNode("h3", _hoisted_12, _toDisplayString(meaning.partOfSpeech.toUpperCase()), 1),
                    _createElementVNode("div", _hoisted_13, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(meaning.definitions, (def, defIndex) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: defIndex,
                          class: "p-2 rounded-md shadow-sm"
                        }, [
                          _createElementVNode("p", _hoisted_14, _toDisplayString(def.definition), 1),
                          (def.example)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(i18n).global.t("dictionary.example")) + " : " + _toDisplayString(def.example), 1))
                            : _createCommentVNode("", true),
                          (def.synonyms.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(i18n).global.t("dictionary.synonyms")) + " : ", 1),
                                _createElementVNode("div", _hoisted_18, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(def.synonyms, (syn, synIndex) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: synIndex,
                                      class: "bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm dark:bg-green-900 dark:text-green-300"
                                    }, _toDisplayString(syn), 1))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (def.antonyms.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(i18n).global.t("dictionary.antonyms")) + " :", 1),
                                _createElementVNode("div", _hoisted_21, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(def.antonyms, (ant, antIndex) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: antIndex,
                                      class: "bg-red-100 text-red-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm dark:bg-red-900 dark:text-red-300"
                                    }, _toDisplayString(ant), 1))
                                  }), 128))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]))
                }), 128)),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictionaryData.value.sourceUrls, (url, index) => {
                      return (_openBlock(), _createElementBlock("a", {
                        key: index,
                        href: url,
                        target: "_blank",
                        class: "text-blue-600 hover:text-blue-800 block"
                      }, _toDisplayString(url), 9, _hoisted_24))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("p", _hoisted_26, [
            _createElementVNode("strong", null, _toDisplayString(_unref(i18n).global.t("vocabulary.translate")) + " : ", 1),
            _createTextVNode(" " + _toDisplayString(selectedVocabulary.value?.translate), 1)
          ]),
          (selectedVocabulary.value?.notes)
            ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                _createElementVNode("strong", null, _toDisplayString(_unref(i18n).global.t("vocabulary.notes")) + " : ", 1),
                _createTextVNode(" " + _toDisplayString(selectedVocabulary.value?.notes), 1)
              ]))
            : _createCommentVNode("", true),
          (selectedVocabulary.value?.example_sentence)
            ? (_openBlock(), _createElementBlock("p", _hoisted_28, [
                _createElementVNode("strong", null, _toDisplayString(_unref(i18n).global.t("vocabulary.example_sentence")) + " :", 1),
                _createTextVNode(" " + _toDisplayString(selectedVocabulary.value?.example_sentence), 1)
              ]))
            : _createCommentVNode("", true),
          (selectedVocabulary.value?.image)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("strong", _hoisted_30, _toDisplayString(_unref(i18n).global.t("image.image")) + " : ", 1),
                _createElementVNode("img", {
                  src: selectedVocabulary.value.image,
                  alt: "Vocabulary Image",
                  class: "rounded-lg shadow-md max-w-full h-auto"
                }, null, 8, _hoisted_31)
              ]))
            : _createCommentVNode("", true),
          (selectedVocabulary.value?.updated_at)
            ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, _toDisplayString(_unref(getRelativeTime)(selectedVocabulary.value?.updated_at)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "width", "placement", "height"]))
}
}

})